"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var step_1 = require("../step");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var CollaboratorButton_1 = require("Project/CollaboratorButton");
var ShareButton_1 = require("Project/ShareButton");
var Utils_1 = require("@CommonFrontendBackend/Projects/Utils");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var PageStatusRow_1 = require("Project/PageStatusRow/PageStatusRow");
var mobx_react_1 = require("mobx-react");
var Configuration_1 = require("Styles/Configuration/Configuration");
var inversify_react_1 = require("inversify-react");
var CreatePageTelemetry_1 = __importDefault(require("../CreatePageTelemetry"));
var types_1 = require("CreatePageFlow/types");
var types_2 = require("CreatePageFlow/types");
var c = (0, BemBuilder_1.default)("create-page-flow-success");
var Success = (function (_super) {
    __extends(Success, _super);
    function Success(props) {
        var _this = _super.call(this, props) || this;
        _this.images = {
            successTickIcon: "".concat(types_1.ASSETS_DIR, "Images/createPage/successTickIcon.svg"),
        };
        return _this;
    }
    Success.prototype.render = function () {
        var _this = this;
        if (!this.props.store.prompts) {
            throw new Error("prompts needed for success!");
        }
        var _a = this.props.store, createdPage = _a.createdPage, pageStateLive = _a.prompts.pageStateLive, hidePageStateLivePrompt = _a.hidePageStateLivePrompt;
        var flowSource = this.props.flowSource;
        if (!createdPage) {
            throw new Error("Created page needed for success!");
        }
        var _b = createdPage.urls, collaboratorUrl = _b.collaboratorUrl, editorUrl = _b.editorUrl, publicUrl = _b.publicUrl;
        var statusChangeCallback = function (status) {
            _this.telemetry.pageStatusChanged(status);
            return _this.props.store.setCreatedPageStatus(status);
        };
        return (react_1.default.createElement("div", { className: c() },
            react_1.default.createElement("div", { className: c("left-panel") },
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement("div", { className: c("heading") },
                        react_1.default.createElement("img", { className: c("icon"), src: this.images.successTickIcon, alt: "" }),
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "2" }, "Page created")),
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Nice work, you've created a new Qwilr page. What do you want to do with it?")),
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement("div", { className: "space-stack-xs" },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Set live and share")),
                    react_1.default.createElement("div", { className: "space-stack-m" },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Nailed it - now it's time to show people what you've made.")),
                    createdPage.status !== Types_1.ProjectStatus.Live && pageStateLive.show && (react_1.default.createElement(kaleidoscope_1.Card, { className: c("prompt") },
                        react_1.default.createElement(kaleidoscope_2.RainbowBar, null),
                        react_1.default.createElement("div", { className: c("prompt-content") },
                            react_1.default.createElement(kaleidoscope_1.IconButton, { className: c("prompt-close"), size: kaleidoscope_1.ButtonSize.Small, onClick: hidePageStateLivePrompt, icon: react_1.default.createElement(icons_1.Close, null) }),
                            react_1.default.createElement("div", { className: "space-stack-s" },
                                react_1.default.createElement(kaleidoscope_1.Heading, { level: "5" }, "Setting a page live")),
                            react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "When a page is set live, it will be accessible to anyone you share the public link with. Live pages allow you to track viewer engagement.")))),
                    react_1.default.createElement(kaleidoscope_1.Card, { className: c("status") },
                        react_1.default.createElement(kaleidoscope_1.Layer, { offset: Configuration_1.modalZIndex }, function () { return (react_1.default.createElement(PageStatusRow_1.PageStatusRow, { status: createdPage.status, hideStatus: false, confirmPageStatusChange: function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                                return [2, true];
                            }); }); }, hasTemplateChildren: false, setStatus: statusChangeCallback, projectId: createdPage._id, gotoPage: undefined, disableManualAcceptance: true, settableStatuses: PageStatusRow_1.SettableStatuses.LiveDraft })); }),
                        react_1.default.createElement(ShareButton_1.ShareButton, { disabled: !(0, Utils_1.isActionAllowed)(createdPage.status, Types_1.ProjectActions.PublicPageView), linkUrl: publicUrl, telemetryCallback: function () {
                                _this.telemetry.publicLinkCopied(_this.props.store.template.crmInfo.integration);
                            } }))),
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement("div", { className: "space-stack-xs" },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Collaborate with your team")),
                    react_1.default.createElement("div", { className: "space-stack-m" },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Want to get an opinion on what you've created?")),
                    react_1.default.createElement("div", { className: c("collaborator") },
                        react_1.default.createElement(CollaboratorButton_1.CollaboratorButton, { type: kaleidoscope_1.ButtonType.Secondary, collaboratorLink: collaboratorUrl, telemetryCallback: function () {
                                _this.telemetry.collaboratorLinkCopied(_this.props.store.template.crmInfo.integration);
                            } }))),
                react_1.default.createElement("div", { className: c("section") },
                    react_1.default.createElement("div", { className: "space-stack-xs" },
                        react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Keep editing")),
                    react_1.default.createElement("div", { className: "space-stack-m" },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Still got a few things you want to tweak before sharing?")),
                    react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, href: function () { return editorUrl; }, onClick: function () { return _this.telemetry.editPageClicked(); } }, "Edit page"))),
            react_1.default.createElement("div", { className: c("right-panel") },
                flowSource == types_2.CreatePageFlowSource.Crm && (react_1.default.createElement("div", { className: c("return-to-crm") },
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, " You can close this browser tab and return to your CRM."))),
                react_1.default.createElement("iframe", { className: c("frame"), src: (0, CommonUtils_1.addParamsToUrl)(collaboratorUrl, { hideCollaboratorNav: "true" }) }))));
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof CreatePageTelemetry_1.default !== "undefined" && CreatePageTelemetry_1.default) === "function" ? _a : Object)
    ], Success.prototype, "telemetry", void 0);
    Success = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [typeof (_b = typeof step_1.StepProps !== "undefined" && step_1.StepProps) === "function" ? _b : Object])
    ], Success);
    return Success;
}(react_1.default.Component));
exports.default = Success;
